module.exports = __webpack_public_path__ + "static/media/Krombacher-SerifRegularItalic.5c1fafaf.woff2";